<template>
    <div class="d-flex border mb-2" style="background-color: #f0f1f2;">
        <button v-if="layoutType !== 'header'" class="btn btn-sm btn-light border p-0" @click="onAddRowClick"
                style="width: 34px; height: 34px;"
                data-bs-toggle="tooltip" data-placement="top" title="add row">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
                <path fill="#5674F0"
                      d="M43,30V18c0-2.2-1.8-4-4-4H9c-2.2,0-4,1.8-4,4v12c0,2.2,1.8,4,4,4h30C41.2,34,43,32.2,43,30z M9,18h30v12L9,30V18z"/>
                <path fill="#43A047" d="M38 28A10 10 0 1 0 38 48A10 10 0 1 0 38 28Z"/>
                <path fill="#FFF" d="M32 36H44V40H32z"/>
                <path fill="#FFF" d="M36 32H40V44H36z"/>
            </svg>
        </button>

        <button v-show="layout.selectedRow && layout.rows.length > 0" class="btn btn-sm btn-light border p-0"
                style="width: 34px; height: 34px;"
                data-bs-toggle="tooltip" data-placement="top" title="duplicate row"
                @click="onDuplicateRowClick">
            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"
                 viewBox="0 0 48 48"
                 style=" fill:#000000;">
                <path fill="#90caf9"
                      d="M47,34V22c0-2.2-1.8-4-4-4H13c-2.2,0-4,1.8-4,4v12c0,2.2,1.8,4,4,4h30C45.2,38,47,36.2,47,34z M13,22h30v12H13V22z"></path>
                <path fill="#90caf9"
                      d="M10,26H5V14h30v5h4v-5c0-2.2-1.8-4-4-4H5c-2.2,0-4,1.8-4,4v12c0,2.2,1.8,4,4,4h5V26z"></path>
                <path fill="#43a047" d="M38 28A10 10 0 1 0 38 48A10 10 0 1 0 38 28Z"></path>
                <g>
                    <path fill="#fff" d="M32 36H44V40H32z"></path>
                    <path fill="#fff" d="M36 32H40V44H36z"></path>
                </g>
            </svg>
        </button>

        <button v-show="layout.selectedRow && layout.rows.length > 1" class="btn btn-sm btn-light border p-0"
                style="width: 34px; height: 34px;"
                data-bs-toggle="tooltip" data-placement="top" title="delete row"
                @click="onDeleteRowClick">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
                <path fill="#5674F0"
                      d="M43,30V18c0-2.2-1.8-4-4-4H9c-2.2,0-4,1.8-4,4v12c0,2.2,1.8,4,4,4h30C41.2,34,43,32.2,43,30z M9,18h30v12L9,30V18z"/>
                <path fill="#F44336" d="M38 28A10 10 0 1 0 38 48A10 10 0 1 0 38 28Z"/>
                <path fill="#FFF" d="M36.5 32H39.5V44H36.5z" transform="rotate(134.999 38 38)"/>
                <path fill="#FFF" d="M36.5 32H39.5V44H36.5z" transform="rotate(-134.999 38 38)"/>
            </svg>
        </button>

        <button v-show="layout.selectedRow || layout.selectedColumn" class="btn btn-sm btn-light border p-0"
                data-bs-toggle="tooltip" data-placement="top" title="add block" style="width: 34px; height: 34px;"
                @click="onAddColumnClick">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
                <path fill="#5674F0" d="M6,42V6h36v36H6z M10,38h28V10H10V38z"/>
                <path fill="#5674F0"
                      d="M24,41.5c-1.104,0-2-0.896-2-2V9c0-1.104,0.896-2,2-2s2,0.896,2,2v30.5C26,40.604,25.104,41.5,24,41.5z"/>
                <path fill="#5674F0"
                      d="M39 21H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 21 39 21zM39 31H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 31 39 31z"/>
                <g>
                    <path fill="#43a047" d="M48,38c0,5.5-4.5,10-10,10s-10-4.5-10-10s4.5-10,10-10S48,32.5,48,38"/>
                    <path fill="#fff" d="M44,36h-4v-4h-4v4h-4v4h4v4h4v-4h4V36z"/>
                </g>
            </svg>
        </button>

        <button v-show="layout.selectedRow && layout.selectedColumn"
                class="btn btn-sm btn-light border p-0" style="width: 34px; height: 34px;"
                data-bs-toggle="tooltip" data-placement="top" title="duplicate block"
                @click="onDuplicateBlockClick">
            <svg xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 48 48" width="24px" height="24px">
                 style=" fill:#000000;">
                <path fill="#90caf9" d="M6,42V6h36v36H6z M10,38h28V10H10V38z"></path>
                <path fill="#90caf9" d="M24,41.5c-1.104,0-2-0.896-2-2V19h4v20.5C26,40.604,25.104,41.5,24,41.5z"></path>
                <path fill="#90caf9"
                      d="M39 21H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 21 39 21zM39 31H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 31 39 31z"></path>
                <g>
                    <path fill="#ab47bc" d="M38,10v7H10v-7H38 M42,6H6v15h36V6L42,6z"></path>
                </g>
                <path fill="#ab47bc" d="M22 8H26V20H22z"></path>
            </svg>
        </button>

        <button v-show="layout.selectedRow && layout.selectedColumn && layout.selectedRow.columns.length > 1"
                class="btn btn-sm btn-light border p-0" style="width: 34px; height: 34px;"
                data-bs-toggle="tooltip" data-placement="top" title="delete block"
                @click="onDeleteColumnClick">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
                <path fill="#5674F0" d="M6,42V6h36v36H6z M10,38h28V10H10V38z"/>
                <path fill="#5674F0"
                      d="M24,41.5c-1.104,0-2-0.896-2-2V9c0-1.104,0.896-2,2-2s2,0.896,2,2v30.5C26,40.604,25.104,41.5,24,41.5z"/>
                <path fill="#5674F0"
                      d="M39 21H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 21 39 21zM39 31H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 31 39 31z"/>
                <g>
                    <path fill="#ff3d00" d="M48,38c0,5.5-4.5,10-10,10s-10-4.5-10-10s4.5-10,10-10S48,32.5,48,38"/>
                    <path fill="#fff"
                          d="M43.3,34.8l-2.1-2.1L38,35.9l-3.2-3.2l-2.1,2.1l3.2,3.2l-3.2,3.2l2.1,2.1l3.2-3.2l3.2,3.2l2.1-2.1L40.1,38L43.3,34.8z"/>
                </g>
            </svg>
        </button>

        <button v-show="layoutType === 'header' && layout.selectedComponent"
                class="btn btn-sm btn-light border p-0" style="width: 34px; height: 34px;"
                data-bs-toggle="tooltip" data-placement="top" title="delete component"
                @click="onDeleteComponentClick">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
                <path fill="#5674F0" d="M6,42V6h36v36H6z M10,38h28V10H10V38z"/>
                <path fill="#5674F0"
                      d="M24,41.5c-1.104,0-2-0.896-2-2V9c0-1.104,0.896-2,2-2s2,0.896,2,2v30.5C26,40.604,25.104,41.5,24,41.5z"/>
                <path fill="#5674F0"
                      d="M39 21H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 21 39 21zM39 31H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 31 39 31z"/>
                <g>
                    <path fill="#ff3d00" d="M48,38c0,5.5-4.5,10-10,10s-10-4.5-10-10s4.5-10,10-10S48,32.5,48,38"/>
                    <path fill="#fff"
                          d="M43.3,34.8l-2.1-2.1L38,35.9l-3.2-3.2l-2.1,2.1l3.2,3.2l-3.2,3.2l2.1,2.1l3.2-3.2l3.2,3.2l2.1-2.1L40.1,38L43.3,34.8z"/>
                </g>
            </svg>
        </button>

        <div class="mx-1 border-left"></div>

        <button v-show="layout.selectedRow && !layout.selectedColumn" class="btn btn-sm btn-light border p-0"
                @click="onResetClick" style="width: 34px; height: 34px;"
                data-bs-toggle="tooltip" data-placement="top" title="reset column widths">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
                <path fill="#5674F0" d="M6,42V6h36v36H6z M10,38h28V10H10V38z"/>
                <path fill="#5674F0" d="M24,41.5c-1.104,0-2-0.896-2-2V19h4v20.5C26,40.604,25.104,41.5,24,41.5z"/>
                <path fill="#5674F0"
                      d="M39 21H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 21 39 21zM39 31H9c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2S40.104 31 39 31z"/>
                <g>
                    <path fill="#ab47bc" d="M38,10v7H10v-7H38 M42,6H6v15h36V6L42,6z"/>
                </g>
                <path fill="#ab47bc" d="M22 8H26V20H22z"/>
            </svg>
        </button>

    </div>
</template>

<script>
    import PageFactory from "../../utils/PageFactory";
    import RowDeleted from "../state/RowDeleted";

    export default {
        name: 'PropertyToolbar',
        props: ['layout', 'layoutType'],
        data() {
            return {
                model: webase.model,
                factory: new PageFactory()
            }
        },
        mounted() {
            // $(function () {
            //     $('[data-bs-toggle="tooltip"]').tooltip()
            // })
        },
        methods: {
            onDeleteComponentClick() {

            },
            onAddRowClick() {

                let labelColumn = this.factory.createLabelColumn('12', 'New Row')
                let row = this.factory.createRow()
                row.columns.push(labelColumn)
                this.layout.rows.push(row)
            },

            onAddColumnClick() {
                let labelColumn = this.factory.createLabelColumn('12', 'New Column')

                // for (let i = 0; i < this.layout.rows.length; i++) {
                //     if (this.layout.rows[i].selected) {
                //         let currentRow = this.layout.rows[i]
                //         currentRow.columns.push(labelColumn)
                //         this.factory.resetColumns(currentRow.columns)
                //     }
                // }

                this.layout.selectedRow.columns.push(labelColumn)
                this.factory.resetColumns(this.layout.selectedRow.columns)
            },

            onDeleteColumnClick() {
                let row = this.layout.selectedRow

                for (let j = 0; j < row.columns.length; j++) {
                    let column = row.columns[j]

                    if (column === this.layout.selectedColumn) {
                        row.columns.splice(j, 1)
                        this.layout.selectedColumn = null
                        this.factory.resetColumns(row.columns)
                        return
                    }
                }
            },

            onDeleteRowClick() {
                console.log('onDeleteRowClick')
                console.log('Type: ' + this.layout.selectedRow.type)

                if(this.layout.selectedRow.type === 'InternalRow') {
                    this.onDeleteInternalRow()
                    return
                }

                for (let j = 0; j < this.layout.rows.length; j++) {
                    let row = this.layout.rows[j]

                    if (row === this.layout.selectedRow) {
                        let action = new RowDeleted(this.layout, row, j)
                        webase.managers.state.addAction(action)

                        this.layout.rows.splice(j, 1)
                        this.layout.selectedRow = null
                        return
                    }
                }
            },

            onDeleteInternalRow() {
                console.log('TODO: need to get the parent column of the internal row!')

                let parentColumn = this.layout.selectedRow.parentColumn
                for (let j = 0; j < parentColumn.value.length; j++) {
                    let columnComponent = parentColumn.value[j]

                    if (columnComponent === this.layout.selectedRow) {
                        parentColumn.value.splice(j, 1)
                        this.layout.selectedRow = null
                        this.layout.selectedComponent = null
                        return
                    }
                }
            },

            onDuplicateRowClick() {
                let newRow = JSON.parse(JSON.stringify(this.layout.selectedRow))
                newRow.selected = false

                for (let j = 0; j < this.layout.rows.length; j++) {
                    let row = this.layout.rows[j]

                    if (row === this.layout.selectedRow) {
                        this.layout.rows.splice(j + 1, 0, newRow)
                        return
                    }
                }
            },

            onDuplicateBlockClick() {
                let newColumn = JSON.parse(JSON.stringify(this.layout.selectedColumn))
                newColumn.selected = false
                this.layout.selectedRow.columns.push(newColumn)
                this.factory.resetColumns(this.layout.selectedRow.columns)
            },

            onResetClick() {
                this.factory.resetColumns(this.layout.selectedRow.columns)
            }
        }
    }
</script>

<style>

</style>
